import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import styled from "@emotion/styled";
import {Language} from "modules/enums";
import {fetchFavVoteSharingImage} from "modules/actions";
import {getFanVoteShareImage, getFanVoteShareImageRequestState} from "modules/selectors";
import {useIsMobile} from "modules/utils";
import {Preloader} from "components";
import successSave from "assets/images/saveSuccess.jpg";
import successSaveMobile from "assets/images/saveSuccessMobile.jpg";

const ModalImage = styled.img`
	width: 100%;
	height: auto;
	margin-bottom: 20px;
`;

const Placeholder = styled.div`
	width: 100%;
	height: 295px;
	display: flex;
	justify-content: center;
	align-items: center;
	background: ${({theme}) => theme.colorPalette.black};
	margin-bottom: 20px;
`;

interface IFanVoteShareImage {
	voteId: number;
}

export const FanVoteShareImage: React.FC<IFanVoteShareImage> = ({voteId}) => {
	const dispatch = useDispatch();
	const {i18n} = useTranslation();
	const lang = i18n.language as Language;
	const {isMobile} = useIsMobile("(max-width: 640px)");

	const shareImage = useSelector(getFanVoteShareImage);
	const {isComplete} = useSelector(getFanVoteShareImageRequestState);
	const defaultImage = isMobile ? successSave : successSaveMobile;
	const assetUrl = shareImage || defaultImage;

	useEffect(() => {
		dispatch(
			fetchFavVoteSharingImage({
				language: lang,
				payload: voteId,
			})
		);
	}, [dispatch, lang, voteId]);

	if (!isComplete) {
		return (
			<Placeholder>
				<Preloader />
			</Placeholder>
		);
	}

	return (
		<React.Fragment>
			<ModalImage src={assetUrl} alt="Team" />
		</React.Fragment>
	);
};
